import React from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Style from '../Styles/Common.module.css';
import BreadcrumbComponent from "../Common/CommonSections/Breadcrum";
import { Link } from "react-router-dom";

const TermsConditionsPage = ()=>{
    return(
        <div>
            <BreadcrumbComponent home='Home' listOne="Terms & Conditions" />
            <div className={Style.pageTitle + ' ' + Style.marginUp90}>
                <Container>
                    <Row>
                        <Col>
                            <div className={Style.sectionTitle}>
                                <h2>Terms & Conditions</h2>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <div className={Style.aboutmayocollege + ' ' + Style.pageBoder}>
                            <p>Thank you for being part of Mayo College Alumni Association Delhi. By engaging with our association, you agree to abide by the following terms and conditions:</p>
                            <h3>Membership Eligibility:</h3>
                            <p>Membership in Mayo College Alumni Association Delhi is open to individuals who have graduated from Mayo College, Ajmer and MCGS, Ajmer. We reserve the right to verify eligibility.</p>
                            <h3>Membership Duration:</h3>
                            <p>Membership is valid for life term. The association may revise membership fees and terms with notice.</p>
                            <h3>Code of Conduct:</h3>
                            <p>Members are expected to adhere to a Code of Conduct, promoting respectful and positive interactions within the association. Violations may result in membership termination.</p>
                            <h3>Use of Information:</h3>
                            <p>Members consent to the collection and use of personal information for association-related purposes, as outlined in the Privacy Policy.</p>
                            <h3>Event Participation:</h3>
                            <p>Participation in association events is voluntary. Mayo College Alumni Association Delhi is not liable for any injuries, damages, or losses incurred during events.</p>
                            <h3>Content Submission:</h3>
                            <p>Members may submit content, including articles, photos, and comments, granting Mayo College Alumni Association Delhi the right to use and display such content for association purposes.</p>
                            <h3>Intellectual Property:</h3>
                            <p>All association-related content, including the logo and website materials, is the intellectual property of Mayo College Alumni Association Delhi.</p>
                            <h3>Governing Law:</h3>
                            <p>These terms and conditions are governed by the laws of of the National Capital Territory of Delhi, India . Any disputes will be subject to the exclusive jurisdiction of the courts in of the National Capital Territory of Delhi, India.</p>
                            <h3>Amendments:</h3>
                            <p>Mayo College Alumni Association Delhi reserves the right to modify these terms and conditions at any time. Changes will be effective upon posting on our website.</p>
                            <h3>Termination:</h3>
                            <p>Mayo College Alumni Association Delhi reserves the right to terminate membership for violations of these terms or any behavior deemed detrimental to the association.</p>
                            <h3>Contact Information:</h3>
                            <p>For any questions or concerns related to these terms and conditions, please contact us at <strong><Link to='mailto:secretary@mayoalumni.in'>secretary@mayoalumni.in</Link></strong> .</p>
                            <p>By continuing to engage with Mayo College Alumni Association Delhi, you acknowledge that you have read, understood, and agreed to these terms and conditions.</p>


                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </div>
    )
}

export default TermsConditionsPage;